export default __webpack_public_path__ + "static/media/basket-blue.ef34b1e8.svg";